// @note needs to be synced with the backend PaymentMethodEnum

const paymentMethodEnum = [
  {
    label: 'iDeal',
    value: 'ideal',
  },
  {
    label: 'Automatische incasso (Direct Debit)',
    value: 'direct-debit',
  },
  // {
  //   label: 'Credit Card',
  //   value: 'credit-card',
  // },
  {
    label: 'Handmatige bank overschrijving',
    value: 'bank-transfer',
  },
];

export default paymentMethodEnum